export default "__VITE_ASSET__Be61QYoJ__"